import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container, IconButton, Drawer, List, ListItem, ListItemText, useTheme, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';

const PublicHeader = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const location = useLocation();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const navItems = [
        { label: 'Home', href: 'https://comturk.com', external: true },
        { label: 'Blog', href: 'https://comturk.com/blog', external: true },
        { label: 'Pricing', href: '/price', external: false },
    ];

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ my: 2 }}>
                Comturk
            </Typography>
            <List>
                {navItems.map((item) => (
                    <ListItem key={item.label} disablePadding>
                        {item.external ? (
                            <Button
                                href={item.href}
                                sx={{ textAlign: 'center', width: '100%', color: 'text.primary' }}
                            >
                                <ListItemText primary={item.label} />
                            </Button>
                        ) : (
                            <Button
                                component={Link}
                                to={item.href}
                                sx={{ textAlign: 'center', width: '100%', color: 'text.primary' }}
                            >
                                <ListItemText primary={item.label} />
                            </Button>
                        )}
                    </ListItem>
                ))}
                <ListItem disablePadding>
                    <Button component={Link} to="/login" sx={{ textAlign: 'center', width: '100%', color: 'text.primary' }}>
                        <ListItemText primary="Login" />
                    </Button>
                </ListItem>
                <ListItem disablePadding>
                    <Button component={Link} to="/signup" sx={{ textAlign: 'center', width: '100%', color: 'primary.main', fontWeight: 'bold' }}>
                        <ListItemText primary="Get Started" />
                    </Button>
                </ListItem>
            </List>
        </Box>
    );

    return (
        <AppBar position="static" color="transparent" elevation={0} sx={{ borderBottom: '1px solid #eee', bgcolor: 'white' }}>
            <Container maxWidth="lg">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        component="a"
                        href="https://comturk.com"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.1rem',
                            color: 'inherit',
                            textDecoration: 'none',
                            flexGrow: 1,
                        }}
                    >
                        COMTURK
                    </Typography>

                    <Typography
                        variant="h6"
                        component="a"
                        href="https://comturk.com"
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.1rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        COMTURK
                    </Typography>

                    <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3, alignItems: 'center' }}>
                        {navItems.map((item) => (
                            item.external ? (
                                <Button
                                    key={item.label}
                                    href={item.href}
                                    sx={{ my: 2, color: 'text.primary', display: 'block', textTransform: 'none', fontSize: '1rem' }}
                                >
                                    {item.label}
                                </Button>
                            ) : (
                                <Button
                                    key={item.label}
                                    component={Link}
                                    to={item.href}
                                    sx={{ my: 2, color: 'text.primary', display: 'block', textTransform: 'none', fontSize: '1rem' }}
                                >
                                    {item.label}
                                </Button>
                            )
                        ))}

                        <Button
                            component={Link}
                            to="/login"
                            variant="text"
                            sx={{ ml: 2, color: 'text.primary', textTransform: 'none', fontSize: '1rem' }}
                        >
                            Login
                        </Button>
                        <Button
                            component={Link}
                            to="/signup"
                            variant="contained"
                            color="primary"
                            sx={{ ml: 1, textTransform: 'none', borderRadius: 2, px: 3 }}
                        >
                            Get Started
                        </Button>
                    </Box>

                    <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="open drawer"
                            onClick={handleDrawerToggle}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>
            <Box component="nav">
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', md: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
                    }}
                >
                    {drawer}
                </Drawer>
            </Box>
        </AppBar>
    );
};

export default PublicHeader;
